import Vue from 'vue';
import knowledgeBaseComponent from './knowledge-base/knowledge-base.vue';
import store from '../common/js/vuex/store';
import knowledgeBaseStore from './knowledge-base/knowledge-base-vuex';
if (!store.hasModule(['knowledgeBaseModule'])) {
	store.registerModule('knowledgeBaseModule', knowledgeBaseStore);
}
Vue.component('knowledge-base', knowledgeBaseComponent);
